// Copyright © 2023 CATTLEytics Inc.

export const getCssVariable = (name: string): string => {
  const style = getComputedStyle(document.body);
  return style.getPropertyValue(name);
};

export const getPrimaryColor = (): string => getCssVariable('--bs-primary');
